import styled, { css } from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div``;

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: ${colors.surfaceContainerHigh};
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  transition: border-color 0.2s;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};

  margin-bottom: 8px;
  display: block;
`;

export const Icon = styled.img``;

export const Input = styled.input`
  display: flex;
  flex: 1;
  border: none;
  background-color: transparent;

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;

export const ToggleVisibilityButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  background: transparent;
  padding: 0;
  margin-left: 8px;
  cursor: pointer;

  color: ${colors.onSurfaceVariant};
`;

export const ContainerError = styled.div`
  display: flex;
  align-items: center;
  margin: 6px 0;
  gap: 6px;

  svg {
    margin-right: 0;
  }

  span {
    font-size: 13px;
    color: ${colors.error};
  }
`;
